import React from 'react'
import Phone from '../../Assets/img/phone.webp'

const Hero2 = () => {
    return (
        <section className="main-hero">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 text-center">
                        <h1>Votre abonnement a expiré </h1>
                        <p>Votre accès aux fonctionnalités de Pressing 360 est temporairement suspendu. Renouvelez votre abonnement pour continuer à profiter d'une gestion optimale de votre pressing.</p>
                    </div>
                    <div className="col-md-6"> 
                        <img src={Phone} alt="" className='img-fluid animated' />
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Hero2